import { useLocation, useModel } from '@umijs/max';
import { useEffect, useState } from 'react';
import {
  Divider,
  Space,
  Swiper,
  Tag,
  Toast,
  FloatingBall,
  Flex,
  Image,
  Dialog,
  Loading
} from 'react-vant';
import './index.less';
import { PhoneO } from '@react-vant/icons';
import clsx from 'clsx';
import { Plus, Edit, Delete } from '@react-vant/icons';
import { getWechatRentDetail, removeWechatRent } from '@/service/rentHouse';
import { history } from '@umijs/max';
import ButtonRentBottom from '../components/ButtonRentBottom';


type rendAndSaleListItemType = {
  sequenceNbr?: number;
  duration?: string;
  type?: string;
  communityName?: string;
  price?: number;
  phone: string;
  tag?: string[];
  layout?: string;
  area?: string;
  title?: string;
  rentType?: string;
  facing?: string;
  roomType?: string;
  decoration?: string;
  floor?: string;
  content?: string;
  urlPathList:string[],
  createBy?: string;
  minBudget?: string;
  maxBudget?: string;
  // auditStatus: publishAuditStatusEnum;
};

const PublishDetail = () => {
  const location = useLocation();
  const { publishId } = location.state as { publishId: string };
  const [wechatRentData, setWechatRentData] = useState<rendAndSaleListItemType>()
 
  const { ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      ownerInformation: model.ownerInformation
    }),
  );
  
  useEffect(() => {
    console.log(publishId, 'location state');
    getWechatRentDetail(publishId).then(res => {
      if (res && res.code === 200) {
        const data = res.data;
        data.urlPathList = res.data.urlPath ? res.data.urlPath.split(',') : []
        
        setWechatRentData(data)
       
      }
    })
  }, [publishId]);
  const icons = [Edit, Delete];

  const JumTo = (index: number) => {
    if (index === 0) { // 编辑
      console.log(66, wechatRentData)
      // 租房1 售房2 求租3 求购4
      switch(wechatRentData?.type) {
        case '1':
          history.push(`/publishSent?sequenceNbr=${wechatRentData?.sequenceNbr}`);
        break;
        case '2':
          history.push(`/publishSent?sequenceNbr=${wechatRentData?.sequenceNbr}`);
        break;
        case '3':
          history.push(`/publishWantSale?sequenceNbr=${wechatRentData?.sequenceNbr}`);
        break;
        case '4':
          history.push(`/publishWantSale?sequenceNbr=${wechatRentData?.sequenceNbr}`);
        break;
      }
      return
    }

    if (index === 1) { // 删除
      Dialog.show({
        title: '确认要删除吗？',
        message: '',
        showCancelButton: true,
        onCancel: () => {
          return true;
        },
        onConfirm: async () => {
          removeWechatRent(wechatRentData?.sequenceNbr).then((res: any) => {
            if (res && res.code === 200) {
              Toast.success('删除成功')
              history.back()
            }
          })
        }
      });
    }
  }
  
  return (
    <div className={'container'}>
      <>
      {wechatRentData?.urlPathList && wechatRentData?.urlPathList.length!==0 && (<Swiper
        autoplay
        loop
        indicator={(total, current) => (
          <div className={'custom-indicator'}>
            {current + 1}/{total}
          </div>
        )}
      >
           { wechatRentData?.urlPathList?.map((image, index) => (
              <Swiper.Item key={index} >
                <Image lazyload height="170"  width="100%" src={image} />
              </Swiper.Item>
            ))}
      </Swiper>)}
      </>
      <div className={'contents'}>
        <div className={'title'}>
          <Space gap={16}>
            <span>{wechatRentData?.rentType}</span>
            <span>{wechatRentData?.decoration}</span>
          </Space>
        </div>
        <div className={'price'}>
          <section className={'price-container'}>
            <span>{wechatRentData?.type === '1' || wechatRentData?.type === '2' ? wechatRentData?.price : `${wechatRentData?.minBudget || 0}~${wechatRentData?.maxBudget || 0}`}</span>
            {wechatRentData?.type === '1' || wechatRentData?.type === '2' ? '元/月' : '元'}
          </section>
          <section>{wechatRentData?.layout}</section>
        </div>
        <div className={'phone'}>
          <section>联系电话：</section>
          <section>
          {wechatRentData?.phone} <PhoneO style={{ marginLeft: 8 }} fontSize={16} />
          </section>
        </div>
        
        <div className={'house-information'}>
          <div>
            <p>{wechatRentData?.layout} </p>
            <span>房型</span>
          </div>
          <div>
            <p>{wechatRentData?.area}</p>
            <span>面积（m²）</span>
          </div>
          <div>
            <p>{wechatRentData?.floor}</p>
            <span>楼层</span>
          </div>
          <div>
            <p>{wechatRentData?.facing}</p>
            <span>朝向</span>
          </div>
        </div>
        <Divider hairline={false} />
        <Space>
          <Tag plain style={{ '--rv-tag-padding': '4px' }}  type="success">
            {wechatRentData?.decoration}
          </Tag>
          <Tag plain style={{ '--rv-tag-padding': '4px' }} type="primary">
          {wechatRentData?.roomType}
          </Tag>
        </Space>
        <div className={'house-description'}>
          <p>房源信息：</p>
          <span>
          {wechatRentData?.content}
          </span>
        </div>
      </div>
      {wechatRentData?.createBy === ownerInformation?.nickName && 
      // <FloatingBall
      //   className="demo-floating-box-menu"
      //   offset={{
      //     right: 50,
      //     bottom: '14vh',
      //   }}
      //   menu={{
      //     items: icons.map((Icon, index) => (
      //       <Flex
      //         align="center"
      //         justify="center"
      //         onClick={() => JumTo(index)}
      //         key={index}
      //         className="menu-item"
      //       >
      //         <Icon />
      //       </Flex>
      //     )),
      //   }}
      // >
      //   {({ active }) => (
      //     <Flex
      //       align="center"
      //       justify="center"
      //       className={clsx('main-button', {
      //         'main-button--active': active,
      //       })}
      //     >
      //       <Plus />
      //     </Flex>
      //   )}
      // </FloatingBall>
      <ButtonRentBottom click={(value) => JumTo(value)} ></ButtonRentBottom>
      }
     
    </div>
  );
};

export default PublishDetail;
